import Tabs from "@/components/Tabs";
import AppLayout from "@/layouts/AppLayout";
import PageHeading from "@/components/PageHeading";
import { useNavigate } from "@/router";
import type { Path } from "@/router";
import { useLocation } from "react-router-dom";
import { useFlags } from "@/hooks/useFeatureFlags";

export default function TabLayout({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  const { pathname } = location;
  const navigate = useNavigate();
  const flags = useFlags();
  const scormFlagEnabled = !!flags["backoffice-scorm-courses"];

  const items = [
    {
      label: scormFlagEnabled ? "Online Courses" : "Online Videos & Assessments",
      to: "/education/videos" as const
    },
    {
      label: "PGM Universities",
      to: "/education/universities" as const
    }
  ];

  return (
    <AppLayout>
      <PageHeading title="Education" />
      <Tabs
        tabItems={items.map(({ label, to }) => ({
          label,
          onClick: () => navigate(to as Path),
          active: (pathname.endsWith("/") ? pathname.slice(0, -1) : pathname) === to
        }))}
      />

      <div className="flex flex-col">{children}</div>
    </AppLayout>
  );
}
